<template>
<div class="page_smart_park page_hezuo pB100">
	<div class="form_wrap">
		<div class="item">
			<div class="title">参观时间</div>
			<!-- <div class="name">2020年11月24日  09:00-12:00</div> -->
			<div class="name">
				<span class="">{{ userTicket.date_at }}</span>
				<span class="pd20">{{ userTicket.beigin_at + '-' + userTicket.end_at }}</span>
			</div>
		</div>
		<div class="item">
			<div class="title">手机号码</div>
			<div class="name">
				<van-field v-model="phone" placeholder="请填写电话（必填）" />
			</div>
		</div>
	</div>
	<!-- 参观者 -->
	<div class="visit_wrap">
		<div class="visit">
			<div class="item" v-for="(item,index) in visitorList" :key="index">
				<div class="icon" @click="removeVisitor(item,index)"></div>
				<div class="item_r">
					<div class="name">{{ item.name }}<span class="tip">{{ '('+item.type_title+')'}}</span></div>
					<div class="xinxi">
						<div class="number">证件号: {{ item.card_no }}</div>
						<div class="price">¥{{ item.type_price }}</div>
					</div>
				</div>
			</div>
			<!-- 添加 -->
			<div class="item add" @click="addVisitor">
				<div class="icon"></div>
				<div class="name">添加参观者</div>
			</div>
		</div>
	</div>
	<!-- 附加服务 -->
	<div class="form_wrap" v-if="servicesArr && servicesArr.length != 0">
		<div class="item">
			<div class="title">附加服务</div>
			<van-checkbox-group v-model="services_list" @change="changeServices">
				<van-checkbox checked-color="#D34444" v-for="item in servicesArr" :key="item.id" :name="item.id">
					<span class="name">{{ item.name }}</span>
					<span class="price">{{ '¥'+ item.prices}}</span>
				</van-checkbox>
			</van-checkbox-group>
		</div>
	</div>
	<!-- 接待员 -->
	<!-- <div class="form_wrap" v-if="receperArr && receperArr.length != 0">
		<div class="item">
			<div class="title">接待员</div>
			<van-checkbox-group v-model="receper_ids" @change="changeReceper">
				<van-checkbox checked-color="#D34444" v-for="item in receperArr" :key="item.id" :name="item.id">
					<span class="name">{{ item.name }}</span>
				</van-checkbox>
			</van-checkbox-group>
		</div>
	</div> -->
	<!-- 配置信息 -->
	<div class="form_wrap" v-if="setInfoArr">
		<div class="item" v-for="(item,index) in setInfoArr" :key="index">
			<div class="title">{{ item.key }}</div>
			<div class="name">
				<van-field v-model="item.value"  :placeholder="'请填写'+item.key" @blur="bindSetInfo" />
			</div>
		</div>
	</div>
	<!-- 提交 -->
	<div class="bottom">
		<div class="bottom_l">共{{ ticketNum ? ticketNum : 0 }}张，合计：<span class="unit">¥</span><span class="price">{{ totalPrice ? totalPrice : 0}}</span></div>
		<div class="action" @click="bindTiJiao">立即购买</div>
	</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
			phone: null,
			userTicket: null, // 用户已选的票务信息
			visitorList: null, // 已选的参观者
			servicesArr: null, // 附加服务
			setInfoArr: null, // 配置信息
			receperArr: null, // 接待员
			services_list: [], // 附加服务 服务ID [1,2]
			receper_ids: [], // 接待员IDs[1,2]
			ticketNum: null, // 票的张数
			totalPrice: null, // 总价 (票总价+附加服务价)
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '个人门票',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						// 获取用户信息
						this.getUserInfo()
						this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
						if(this.userTicket){
							// 获取票所在 园区或园区下场馆的附加服务
							this.getServices()
						}
						this.visitorList = localStorage.getItem('visitorList') ? JSON.parse(localStorage.getItem('visitorList')) : []
						if(this.visitorList.length != 0){
							this.updatePrice()
						}
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			// 获取用户信息
			this.getUserInfo()
			this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
			if(this.userTicket){
				// 获取票所在 园区或园区下场馆的附加服务
				this.getServices()
			}
			this.visitorList = localStorage.getItem('visitorList') ? JSON.parse(localStorage.getItem('visitorList')) : []
			if(this.visitorList.length != 0){
				this.updatePrice()
			}
        }
		
		
        
    },
	mounted() {
		this.visitorList = localStorage.getItem('visitorList') ? JSON.parse(localStorage.getItem('visitorList')) : []
		console.log('mounted:',this.visitorList)
			if(this.visitorList.length != 0){
				this.updatePrice()
			}
	},
	destroyed() {
		var that = this
		// console.log('销毁了吗=====')
		localStorage.removeItem('visitorList')
		localStorage.removeItem('setInfoArr')
		localStorage.removeItem('services_list')
		localStorage.removeItem('receper_ids')
	},
    methods: {
		// 获取用户信息
		getUserInfo(){
			var that = this
			var params = {
                token: that.token
            }
            that.$api.user.index(params).then(res => {
                if (res.code == 200) {
					that.phone = res.result.info.username
                } 
            })
		},
		// 添加参观者
		addVisitor(){
			var that = this
			var tempVisitorList = []
			if (this.visitorList.length > 0) {
				for (let i = 0; i < this.visitorList.length; i++) {
					const visitor = this.visitorList[i];
					var temp = {
						id: visitor.id,
						type_id: visitor.type_id,
						type_title: visitor.type_title,
						type_price: visitor.type_price
					}
					tempVisitorList.push(temp)
				}
				localStorage.setItem('tempVisitorList',JSON.stringify(tempVisitorList))
			}
			that.$router.push('/visitor/list')
		},
		// 移除参观者
		removeVisitor(item,index){
			var that = this
			console.log('index===',index)
			that.visitorList.splice(index,1)
			localStorage.setItem('visitorList',JSON.stringify(that.visitorList))
			// console.log('参观者',that.visitorList)
			that.updatePrice()
		},
		// 附加服务
		getServices(){
			var that = this
			var params = {
				token: that.token,
				venue_id: that.userTicket.venue_id,
				smarkpark_id: that.userTicket.smarkpark_id,
				is_through_ticket: that.userTicket.is_through_ticket,
				ticket_id: that.userTicket.id,
				sorce: 0
			}
			that.$api.smartpark.setinfo(params).then(res=>{
				if(res.code == 200){
					// 附加服务
					that.servicesArr = res.result.smarkpark_additional_services
					// 缓存中有已选服务,显出出来
					var services_list = localStorage.getItem('services_list')
					if(services_list){
						that.services_list = JSON.parse(services_list)
					}
					// 配置信息
					var arr = []
					var enterinfo = res.result.smartpark_enterinfo_set
					for (var i in enterinfo) {
                        arr.push({
                            key: enterinfo[i].name,
                            value: ''
                        });
                    }
					that.setInfoArr = arr
					// 缓存中有配置信息,显示出来
					var setInfoArr = localStorage.getItem('setInfoArr')
					if(setInfoArr){
						that.setInfoArr = JSON.parse(setInfoArr)
					}
					// 接待员
					// that.receperArr = res.result.smartpark_receper
					// // 缓存中有接待员,显出出来
					// var receper_ids = localStorage.getItem('receper_ids')
					// if(receper_ids){
					// 	that.receper_ids = JSON.parse(receper_ids)
					// }
				}
			})
		},
		// 更新价格
		updatePrice(){
			var that = this
			var price = 0
			var num = 0
			var visitorList = that.visitorList
			// 用户票价
			for(var i in visitorList){
				num ++
				price = price + parseFloat(visitorList[i].type_price)
			}
			that.ticketNum = num
			// 附加服务费
			var list = that.services_list
			var servicesArr = that.servicesArr
			for(var i in list){
				for(var j in servicesArr){
					if(list[i] == servicesArr[j].id){
						price = price + parseFloat(servicesArr[j].prices)
					}
				}
			}
			that.totalPrice = price.toFixed(2)
		},
		// 选择服务
		changeServices(){
			var that = this
			// 存下已选服务
			localStorage.setItem('services_list',JSON.stringify(that.services_list))
			// 更新费用
			that.updatePrice()
		},
		// 选择接待员
		changeReceper(){
			var that = this
			// 存下已选服务
			localStorage.setItem('receper_ids',JSON.stringify(that.receper_ids))
		},
		// 配置信息
		bindSetInfo(){
			var that = this
			// 存下已填写的配置信息
			localStorage.setItem('setInfoArr',JSON.stringify(that.setInfoArr))
			// console.log('配置信息',that.setInfoArr)
		},
		// 提交
		bindTiJiao(){
			var that = this
			var params = {
				token: that.token,
				ticket_id: that.userTicket.id,
			}
			// 参观者
			if(that.visitorList.length == 0){
				that.$toast('请添加参观者')
				return
			}
			var arr = []
			for(var i in that.visitorList){
				var obj = {}
				obj.visitor_id = that.visitorList[i].id
				obj.type_id = that.visitorList[i].type_id
				arr.push(obj)
				params.visitor_list = arr
			}
			// 附加服务
			if( that.services_list.length != 0){
				params.services_list = that.services_list
			}
			// 接待员
			if(that.receper_ids.length != 0){
				params.receper_ids = that.receper_ids
			}
			// 配置信息
			var enterinfo = []
			for(var i in that.setInfoArr){
				var item = that.setInfoArr[i]
				var obj = {}
				obj[item.key] = item.value
				// console.log(that.setInfoArr[i],item.value)
				enterinfo.push(obj)
				params.enterinfo = enterinfo
			}
			console.log('参数===',params)
			// console.log('services_list',that.services_list)
			// console.log('setInfoArr',that.setInfoArr)
			that.$api.smartpark.userorder(params).then(res=>{
				if(res.code == 200){
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/smartpark/pay?pay_order_num='+res.result.pay_order_num+'&price='+res.result.total_prices+'&order_sn='+res.result.order_sn
								}
							}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 跳转支付页
						that.$router.push({
							path: '/smartpark/pay',
							query: {
								pay_order_num: res.result.pay_order_num, // 支付订单号
								price: res.result.total_prices,
								order_sn: res.result.order_sn, // 订单号
							}
						})
					}
					
				}
			})
		}

    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
